import { useForm } from 'react-hook-form';
import { z } from 'zod';
import { zodResolver } from '@hookform/resolvers/zod';

import { zUrl } from '@synapex/tools/utils';

//schema
export const schema = z.object({
  site_url: zUrl({
    nonEmpty: 'Введите адрес сайта',
    url: 'Это неправильный адрес',
  }),
});

export type FormInputValues = z.input<typeof schema>;
export type FormOutputValues = z.output<typeof schema>;

export const DEFAULT_FORM_VALUES: FormInputValues = {
  site_url: '',
};

export const useCreateSiteForm = () =>
  useForm({
    resolver: zodResolver(schema),

    defaultValues: DEFAULT_FORM_VALUES,
  });
